export interface CreateComment {
  id: string;
  comment: string;
}
